import { render, staticRenderFns } from "./BreathingTraining.vue?vue&type=template&id=8b0851a0&scoped=true&"
import script from "./BreathingTraining.vue?vue&type=script&lang=js&"
export * from "./BreathingTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0851a0",
  null
  
)

export default component.exports